// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2eYkO","info":"UpdateTermsInfo_info__2jcSX"};